import axios from 'axios';
import { SERVER_ROUTE } from '../routes/api/api_routes';

// Token management
export const getToken = () => {
    try {
        const auth = JSON.parse(localStorage.getItem('auth'));
        return auth?.access || null;
    } catch (error) {
        console.error('Error getting token:', error);
        return null;
    }
};

export const setToken = (token) => {
    try {
        localStorage.setItem('auth', JSON.stringify({ access: token }));
        // Set default authorization header
        axios.defaults.headers.common['Authorization'] = `JWT ${token}`;
    } catch (error) {
        console.error('Error setting token:', error);
    }
};

export const removeToken = () => {
    try {
        localStorage.removeItem('auth');
        delete axios.defaults.headers.common['Authorization'];
    } catch (error) {
        console.error('Error removing token:', error);
    }
};

// User management
export const getCurrentUser = () => {
    try {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        return user || null;
    } catch (error) {
        console.error('Error getting current user:', error);
        return null;
    }
};

export const setCurrentUser = (user) => {
    try {
        localStorage.setItem('currentUser', JSON.stringify(user));
    } catch (error) {
        console.error('Error setting current user:', error);
    }
};

export const removeCurrentUser = () => {
    try {
        localStorage.removeItem('currentUser');
    } catch (error) {
        console.error('Error removing current user:', error);
    }
};

// Role management
export const isAdmin = () => {
    const user = getCurrentUser();
    return user?.is_admin || false;
};

export const isCoach = () => {
    const user = getCurrentUser();
    return user?.is_coach || false;
};

// Session management
export const checkSession = () => {
    const token = getToken();
    const user = getCurrentUser();
    return !!(token && user);
};

// API configuration
export const configureAxios = () => {
    axios.defaults.baseURL = SERVER_ROUTE;
    axios.defaults.timeout = 10000; // 10 seconds timeout
    axios.defaults.headers.common['Content-Type'] = 'application/json';

    const token = getToken();
    if (token) {
        axios.defaults.headers.common['Authorization'] = `JWT ${token}`;
    }

    // Add response interceptor for token refresh
    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            if (error.response?.status === 401) {
                // Token expired or invalid
                removeToken();
                removeCurrentUser();
                window.location.href = '/login';
            }
            return Promise.reject(error);
        }
    );
}; 